import { Box, styled } from '@mui/material';

export const ShellRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: 'calc(100vh - 70px)'
});

export const ContentArea = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden'
});
